import { NavLink } from "react-router-dom";
import "./Menu.css";

export default function Menu() {
  return (
    <header className="menu-bar">
      <NavLink
        to="/home"
        className="menu-brand"
        aria-label="Retour à l'accueil"
      >
        Pdf-Convert
      </NavLink>

      <nav className="menu-links" aria-label="Navigation principale">
        <NavLink
          to="/conversion"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Conversion
        </NavLink>

        <NavLink
          to="/fusion"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Fusion
        </NavLink>

        <NavLink
          to="/reduction"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Réduction d’image
        </NavLink>
      </nav>
    </header>
  );
}
